import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type LogsIconProps = IconProps;

const LogsIcon: FC<LogsIconProps> = ({ iconColor = '#344054', className, ...props }) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6667 9.16669H6.66666M8.33333 12.5H6.66666M13.3333 5.83335H6.66666M16.6667 5.66669V14.3334C16.6667 15.7335 16.6667 16.4335 16.3942 16.9683C16.1545 17.4387 15.772 17.8212 15.3016 18.0609C14.7669 18.3334 14.0668 18.3334 12.6667 18.3334H7.33333C5.9332 18.3334 5.23313 18.3334 4.69835 18.0609C4.22795 17.8212 3.8455 17.4387 3.60581 16.9683C3.33333 16.4335 3.33333 15.7335 3.33333 14.3334V5.66669C3.33333 4.26656 3.33333 3.56649 3.60581 3.03171C3.8455 2.56131 4.22795 2.17885 4.69835 1.93917C5.23313 1.66669 5.9332 1.66669 7.33333 1.66669H12.6667C14.0668 1.66669 14.7669 1.66669 15.3016 1.93917C15.772 2.17885 16.1545 2.56131 16.3942 3.03171C16.6667 3.56649 16.6667 4.26656 16.6667 5.66669Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default LogsIcon;
